export enum UserRoles {
  OrganizationAdmin = "organization-admin",
  OrganizationManager = "organization-manager",
  LeagueAdmin = "league-admin",
  LeagueManager = "league-manager",
  CompetitionAdmin = "competition-admin",
  CompetitionManager = "competition-manager",
  SeasonAdmin = "season-admin",
  SeasonManager = "season-manager",
  FixtureManager = "fixture-manager",
  EntityGroupAdmin = "entitygroup-admin",
  EntityGroupManager = "entitygroup-manager",
  EntityManager = "entity-manager",
  RoleManager = "role-manager",
  SupportObserver = "support-observer",
}
